import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getPeopleCurrentOptions } from 'client/@tanstack/react-query.gen';
import { zPipelineTypeFilter } from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

export const newPipelineSearchSchema = z.object({
  from: z.string().optional().catch(undefined),
  function_expertise: zFiltersArray(),
  industry_expertise: zFiltersArray(),
  point_of_contact_person_id: z.string().optional().catch(undefined),
  type: zPipelineTypeFilter.optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/pipelines/new',
)({
  beforeLoad: async ({ context, params, search }) => {
    const { queryClient } = context;
    const pUser = queryClient.ensureQueryData(getPeopleCurrentOptions());
    const [person] = await Promise.all([pUser]);
    const internalRole = person.roles?.find(
      (role) => role.title === 'Banff Admin',
    );
    if (internalRole) {
      throw redirect({
        search: { ...search, team_slug: params.teamId },
        to: '/pipelines/new',
      });
    }
  },
  validateSearch: newPipelineSearchSchema,
});
